export interface IRiskSettingEdit {
    id: string;
    riskProcessInUse: boolean;
    riskStandardInUse: boolean;
    riskStakeholderInUse: boolean;
    riskProcessName: string;
}

export class RiskSettingEdit implements IRiskSettingEdit {
    id: string;
    riskProcessInUse: boolean;
    riskStandardInUse: boolean;
    riskStakeholderInUse: boolean;
    riskProcessName: string;

    constructor();
    constructor(obj: IRiskSettingEdit);
    constructor(obj?: any) {
        this.id = obj && obj.id || "";
        this.riskProcessInUse = obj && obj.riskProcessInUse || false;
        this.riskStandardInUse = obj && obj.riskStandardInUse || false;
        this.riskStakeholderInUse = obj && obj.riskStakeholderInUse || false;
        this.riskProcessName = obj && obj.riskProcessName || "";
    }
}

export type TRiskSettingEditSave = {
    companyId: string;
    riskProcessInUse: boolean;
    riskStandardInUse: boolean;
    riskStakeholderInUse: boolean;
    riskProcessName: string;
}